import React, { useMemo } from "react";
import {useDataWithRoute} from "../utils/hooks";
import {VsiBubbleFavs} from "../styled/App.styled";
import VerticalBarChart from "../components/VerticalBarChart";
import {Spinner} from "reactstrap";
import { useVsiAppContext } from "../stores/VsiApp";
import { capitalizeWord } from "../utils/Helpers";

const sortingArr = ['local', 'remote'];

export default function EnterpriseSnap({  params  }) {
    const { client: { clientId }, getPeriodId } = useVsiAppContext();
    const periodId = getPeriodId("STORAGE");

    const route = useMemo(() => `/api/v6/report/enterprise_snap_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);
    const [{ recordset }, {isLoading}] = useDataWithRoute(route);

    const { graphData, allFilCats } = useMemo (() => {
        const localArr = [];
        const remoteArr = [];

        recordset.forEach(datum => {
            if (datum.local_remote === "local") {
                localArr.push(datum)
            } else if (datum.local_remote === "remote") {
                remoteArr.push(datum)
            }
        });

        const allCats = localArr.reduce((acc, datum) => {
        const val = datum[params?.[0]?.value ??  "classification"];
            if (!acc.includes(val)) acc.push(val);
            return acc;
        }, []);

        // Local only
        const localNewData = [];
        for (let i = 0; i < allCats.length; i++) {
            let snapUsed = 0;
            for (let y = 0; y < localArr.length; y++) {
                if (allCats[i] === localArr[y][params?.[0]?.value ?? "classification"]) {
                    snapUsed = snapUsed + localArr[y].snap_used;
                }
            }
            localNewData.push(parseFloat((snapUsed).toFixed(2)));
        }


        // Remote only
        const remoteNewData = [];
        for (let i = 0; i < allCats.length; i++) {
            let snapUsed = 0;
            for (let y = 0; y < remoteArr.length; y++) {
                if (allCats[i] === remoteArr[y][params?.[0]?.value ?? "classification"]) {
                    snapUsed = snapUsed + remoteArr[y].snap_used;
                }
            }
            remoteNewData.push(parseFloat((snapUsed).toFixed(2)));
        }

        const finalArray = [localNewData, remoteNewData];
        const chartInfo = [];

        for (let i = 0; i < sortingArr.length; i++) {
            chartInfo.push({
                name: sortingArr[i],
                data: finalArray[i]
            });
        }

        return {
            graphData: chartInfo,
            allFilCats: allCats,
        }

    }, [recordset, params]);

    return isLoading ? (
      <Spinner color={"success"}/>
      ) : (
            <VsiBubbleFavs>
                <VerticalBarChart
                    categories={allFilCats}
                    includeLegend={true}
                    xTitle={capitalizeWord(params?.[0]?.value) || "Classification"}
                    series={graphData}
                    yTitle1={"GiB"}
                    height={420}
                />
            </VsiBubbleFavs>
    )
}